<template>
	<div class="header-logo-container" @click="handleImageClick()">
		<img :alt="`${getStoreName} image`" @load="logoLoaded" src="../../../assets/store-logo.png">
	</div>
</template>

<script>
	import navigationMixin from '@Mixin/navigationMixin';
	import routeMixin from '@Mixin/routeMixin';
	export default {
		mixins: [
			navigationMixin,
			routeMixin,
		],
		computed: {
			getStoreName() {
				const appConstants = this.$appConstants;
				const storeName = appConstants.storeName;
				return storeName;
			},
		},
		methods: {
			logoLoaded(data) {
				const container = this.$el;
				const image = data.currentTarget;
				const height = image.naturalHeight;
				const width = image.naturalWidth;
				const ratio = width/height;
				if (ratio > 1) {
					container.classList.add('wide-logo');
					return;
				}
				container.classList.add('tall-logo');
			},
			handleImageClick() {
				if (this._isGreetingRoute) {
					return;
				}
				this._navigateToHome();
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@include mobile {
		.header-logo-container {
			display: flex;
			align-items: center;
			height: $mobileNavigationHeight;
			img {
				max-height: 36px;
				max-width: 36px;
			}
			&.wide-logo {
				img {
					max-height: $mobileNavigationHeight;
					width: 45vw;
					max-width: 256px;
				}
			}
		}
	}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/header/NavigationItems/HeaderLogo.vue